module.exports = __webpack_public_path__ + "static/media/icon.5bc32c95.png";